import { cn } from '@plato/ui/util/classes';
import * as React from 'react';

const QuoteOrderTimelineTable = React.forwardRef<HTMLTableElement, React.HTMLAttributes<HTMLTableElement>>(
    ({ className, ...props }, ref) => (
        <div className="relative w-full overflow-auto">
            <table ref={ref} className={cn('w-full caption-bottom text-sm', className)} {...props} />
        </div>
    ),
);
QuoteOrderTimelineTable.displayName = 'QuoteOrderTimelineTable';

const QuoteOrderTimelineTableHeader = React.forwardRef<
    HTMLTableSectionElement,
    React.HTMLAttributes<HTMLTableSectionElement>
>(({ className, ...props }, ref) => (
    <thead ref={ref} className={cn('border-b-neutral-100 [&_tr]:border-b', className)} {...props} />
));
QuoteOrderTimelineTableHeader.displayName = 'QuoteOrderTimelineTableHeader';

const QuoteOrderTimelineTableBody = React.forwardRef<
    HTMLTableSectionElement,
    React.HTMLAttributes<HTMLTableSectionElement>
>(({ className, ...props }, ref) => (
    <tbody ref={ref} className={cn('[&_tr:last-child]:border-0', className)} {...props} />
));
QuoteOrderTimelineTableBody.displayName = 'QuoteOrderTimelineTableBody';

const QuoteOrderTimelineTableRow = React.forwardRef<
    HTMLTableRowElement,
    React.HTMLAttributes<HTMLTableRowElement>
>(({ className, ...props }, ref) => (
    <tr
        ref={ref}
        className={cn(
            ' data-[state=selected]:bg-muted border-b border-b-neutral-100 transition-colors',
            className,
        )}
        {...props}
    />
));
QuoteOrderTimelineTableRow.displayName = 'QuoteOrderTimelineTableRow';

const QuoteOrderTimelineTableHead = React.forwardRef<
    HTMLTableCellElement,
    React.ThHTMLAttributes<HTMLTableCellElement>
>(({ className, ...props }, ref) => (
    <th
        ref={ref}
        className={cn(
            'px-2 pb-2 pt-4 text-left  align-middle font-medium text-neutral-500 first:pl-4 last:pr-4 text-sm [&:has([role=checkbox])]:pr-0 *:[[role=checkbox]]:translate-y-[2px]',
            className,
        )}
        {...props}
    />
));
QuoteOrderTimelineTableHead.displayName = 'QuoteOrderTimelineTableHead';

const QuoteOrderTimelineTableCell = React.forwardRef<
    HTMLTableCellElement,
    React.TdHTMLAttributes<HTMLTableCellElement>
>(({ className, ...props }, ref) => (
    <td
        ref={ref}
        className={cn(
            'h-12 px-2 align-middle text-sm font-normal text-neutral-800 first:pl-4 last:pr-4',
            '[&:has([role=checkbox])]:pr-0 *:[[role=checkbox]]:translate-y-0.5',
            className,
        )}
        {...props}
    />
));
QuoteOrderTimelineTableCell.displayName = 'QuoteOrderTimelineTableCell';

export {
    QuoteOrderTimelineTable,
    QuoteOrderTimelineTableBody,
    QuoteOrderTimelineTableCell,
    QuoteOrderTimelineTableHead,
    QuoteOrderTimelineTableHeader,
    QuoteOrderTimelineTableRow,
};
